// @flow
import template from '../../template';

/**
 * @private
 */
export default (): string => template`
  export default function routes() {

  }
`;
